module.exports = __webpack_public_path__ + "static/media/beverage-coffee-cup-svgrepo-com.3ae6be29.svg";